<label>{{ filter.label }}</label>
<div class="d-inline-flex">
  <select [(ngModel)]="filter.operator" class="form-control" (change)="filterChange.emit(filter)">
    <option value="in">est</option>
  </select>

  <div class="ml-2">
    <select [(ngModel)]="filter.tempValue" class="form-control max-width-240px" (ngModelChange)="filterChange.emit(filter)">
      <option [value]="[TypeSalesSupportActions.COMMENTARY]" jhiTranslate="filters.sales-support-actions.COMMENTARY"></option>
      <option [value]="[TypeSalesSupportActions.CLOSE]" jhiTranslate="filters.sales-support-actions.CLOSE"></option>
      <option [value]="[TypeSalesSupportActions.PHONE_REMINDER]" jhiTranslate="filters.sales-support-actions.PHONE_REMINDER"></option>
      <option [value]="[TypeSalesSupportActions.MAIL_REMINDER]" jhiTranslate="filters.sales-support-actions.MAIL_REMINDER"></option>
    </select>
  </div>
</div>
